module.exports = __webpack_public_path__ + "static/img/wifi.4986fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wifi.png
// module id = JtJJ
// module chunks = 4